import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

/**
 * ThemeToggle — a small pill with an animated sun/moon.
 *
 * The two icons are stacked absolutely; on theme change we cross-fade + rotate
 * so the switch feels intentional rather than binary. Colours come entirely from
 * theme tokens so the toggle looks equally at home in dark and light modes.
 */
const ThemeToggle = ({ compact = false }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      data-testid="theme-toggle"
      className={`group relative inline-flex items-center justify-center rounded-full border border-ink/20 hover:border-ink/45 transition-colors duration-500 ${
        compact ? "w-9 h-9" : "w-10 h-10"
      }`}
    >
      <span className="relative w-4 h-4 block">
        <Sun
          className={`absolute inset-0 w-4 h-4 text-ink transition-all duration-500 ${
            isDark ? "opacity-0 rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"
          }`}
          strokeWidth={1.7}
        />
        <Moon
          className={`absolute inset-0 w-4 h-4 text-ink transition-all duration-500 ${
            isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-50"
          }`}
          strokeWidth={1.7}
        />
      </span>
    </button>
  );
};

export default ThemeToggle;
